import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const TableHeader = ({ sortColumn, setSortColumn, sortOrder, setSortOrder }) => {
  const handleSortToggle = (column) => {
    const isSameColumn = sortColumn === column;
    const newSortOrder = isSameColumn && sortOrder === 'ASC' ? 'DESC' : 'ASC';

    setSortColumn(column);
    setSortOrder(newSortOrder);
  };

  const renderSortIcon = (column) => {
    if (sortColumn !== column) return null;
    return sortOrder === 'ASC' ? (
      <ArrowUpwardIcon className="!text-lg ml-1 text-minima-orange-2023" />
    ) : (
      <ArrowDownwardIcon className="!text-lg ml-1 text-minima-orange-2023" />
    );
  };

  return (
    <thead className="text-[14px] font-semibold text-core-grey-60 bg-core-black-contrast-2">
      <tr>
        {[
          { key: 'FILE_NAME', label: 'File name', width: '16%' },
          { key: 'FILE_LABEL', label: 'File label', width: '16%' },
          // { key: 'FILE_SIZE', label: 'File size', width: '12%' },
          { key: 'VALIDATION_DATE', label: 'Validation date', width: '20%' },
          { key: 'VALID', label: 'Result', width: '20%' },
        ].map(({ key, label, width }) => (
          <th
            key={key}
            className={`w-[${width}] p-4 cursor-pointer `}
            onClick={() => handleSortToggle(key)}
          >
            <div className="flex items-center">
              {label}
              {renderSortIcon(key)}
            </div>
          </th>
        ))}
        <th className="w-[12%] p-4">Report</th>
        <th className="w-[8%] p-4">PDF</th>
        <th className="w-[8%] p-4"></th>
      </tr>
    </thead>
  );
};

export default TableHeader;
